import { render } from "./AppHeader.vue?vue&type=template&id=6ddd32fc&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=6ddd32fc&scoped=true&lang=css"

import exportComponent from "/home/nicky/htdocs/vuejs-tailwindcss-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddd32fc"]])

export default __exports__